import { DISTRIBUTOR_ALIASES, CONTRACTOR_TYPE_MARKET_ORG } from './contractor-types.constants';

export const DISTRIBUTOR_FIELD_FETCH_PARAMS = {
  contractor_type_aliases: DISTRIBUTOR_ALIASES,
};

export const MARKETING_ORGANISATION_FIELD_FETCH_PARAMS = {
  contractor_type_aliases: [CONTRACTOR_TYPE_MARKET_ORG],
};
